import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-08-19'
        tag='-'
        title='Selling on Multiple Marketplaces: Is It Worth It?'
      >
        <p>
          Over the years, e-commerce has redefined the way we live. It has created jobs and opportunities to earn
          additional income. From selling and buying in-demand products anytime and anywhere, e-commerce provides
          convenience in an innovative way.
        </p>
        <p>
          In 2019, China accounted for $740 billion of e-commerce sales while the US contributed over $560 billion. By
          2023, the US is expected to reach $735 billion in sales. The global e-commerce market is steadily growing. As
          more people use online marketplaces to buy and sell, sales will continue to increase – and there are different
          factors that contribute to this.
        </p>

        <h3>The rise of technology</h3>
        <p>
          In this digital age, the use of devices like smartphones, tablets, and laptops has made life easier. With a
          few clicks and a press of buttons, you can easily call, message, consume entertaining content, and transact to
          and from anywhere in the world.
        </p>
        <p>
          Purchasing online has become exponentially easier over the years. People no longer need to visit physical
          stores to purchase what they need or want. The option still exists, but if you lack time, online shopping is
          your best bet.
        </p>

        <h3>Ultimate convenience</h3>
        <p>
          Online shopping has rapidly become a preferred shopping method for many. With a few clicks, people can easily
          buy and sell anything from anywhere. Anything can be delivered. From personal needs, clothing, books, and
          electronics to furniture and home appliances.
        </p>
        <p>
          Additionally, online marketplaces provide avenues for personalization. Sellers can choose where and what to
          sell. Similarly, customers can sift through the online shops that offer what they want without having to
          physically move or go out.
        </p>
        <p>
          Different marketplaces also have categories and specialties. Kidizen, for example, sells kids’ clothing,
          shoes, and accessories. Poshmark Is primarily geared toward women’s fashion. eBay and Craigslist are used for
          a little bit of everything.
        </p>

        <h3>Overall low cost</h3>
        <p>
          Establishing an online shop is relatively easier and sometimes cheaper than having a physical one. You don’t
          need to search for a physical location to purchase or rent. You also don’t need to find contractors and other
          people to help build your store.
        </p>
        <p>
          For online shops, you only need to come up with branding, decide on your products, and find a marketplace that
          best suits your vision and needs. But even with these additional expenses, they are minor compared to a
          brick-and-mortar location. One of the only things you need to do is calculate your items’ price, shipping fee,
          and marketplace fee. Selling online allows you to start right away as opposed to the time it takes to set up a
          physical store.
        </p>

        <h3>Pros and cons of selling on multiple sites</h3>
        <p>
          Whether you are already a reseller or gearing up to be one, there are many factors to consider in selling on
          different platforms.
        </p>
        <p>
          For those familiar with the reselling experience, managing a business is no walk in the park. It takes time,
          effort, and strategy to have your listings noticed by potential customers. This alone can be daunting as you
          are competing with thousands of other resellers. You always need to come up with creative ways to market your
          business.
        </p>
        <p>
          But if you are thinking about earning more by selling on more than one marketplace, here are some benefits and
          disadvantages you should take note of.
        </p>
        <h4>Advantages</h4>
        <ul>
          <li>
            <strong>Increased exposure</strong>
            <p>
              The first thing you want once your listings are published is to attract the attention of as many users as
              possible. When you post on different websites or apps, you increase your chances of getting noticed.
              Sometimes, there are customers that are loyal to one marketplace, so by crosslisting your items, you are
              reaching these single-platform users as well.
            </p>
          </li>
          <li>
            <strong>Increased income</strong>
            <p>
              With greater exposure to your listings comes the opportunity to gain additional profit. When you are
              listing on two or more marketplaces, your item’s exposure will increase. Naturally, this increases the
              chance that someone will purchase your items.
            </p>
            <p>
              Crosslisting alone will not guarantee you sales. A great deal of it still relies on your item type and how
              you market them (attractive photos, complete and relevant item descriptions, and occasional promos and
              discounts).
            </p>
          </li>
        </ul>
        <h4>Disadvantages</h4>
        <ul>
          <li>
            <strong>Time-consuming</strong>
            <p>
              Selling on one marketplace already takes time. Sometimes you get inquiries or likes that do not result in
              sales. Creating listings Sometimes, you have little time to pack orders and ship them with your busy
              schedule.
            </p>
            <p>
              Reselling can be challenging at times. What more when you are doing these on different websites or apps
              all at once? You will likely get exhausted, especially when you do all these tasks manually. Before you
              know it, you end up giving up on this good opportunity as you are not strategic about it.
            </p>
          </li>
          <li>
            <strong>Delisting and canceling orders</strong>
            <p>Sellers have repeatedly made this mistake: accidentally selling the same item on two different sites.</p>
            <p>
              For example, you sold Lululemon Athletica yoga pants on Poshmark. However, you forgot that you have this
              same listing on Mercari. A week later, a customer also purchased the exact item, but you have shipped this
              to the Poshmark client already.
            </p>
            <p>
              In the end, you’d have to delist the item and cancel the Mercari order. Making this mistake is common but
              still causes inconvenience both to you and the customer. It gets worse if you repeat it, as you will lose
              credibility as a seller. Your feedback rating decreases, and potential buyers will no longer browse
              through your shop.
            </p>
          </li>
        </ul>

        <h3>Automate your reselling business</h3>
        <p>
          Any reseller would want to increase their visibility so it would help translate into sales. But given the cons
          of selling on multiple platforms, how do you pull this off? The answer is to automate. Use service apps like
          OneShop that performs all these tasks for you.
        </p>
        <p>
          OneShop has cross-listing and relisting features that help you automatically cross-post your listings to other
          eCommerce platforms. It is available on top sites like eBay, Poshmark, Mercari, and Depop. You don’t need to
          manually repost anymore, which saves you time.
        </p>
        <p>
          In crosslisting, the Listing Form can be tedious to fill in. This is why OneShop has streamlined it such that
          categories, prices, and shipping information are grouped together. These are the crucial details, after all,
          so you need to prioritize before the rest.
        </p>
        <p>
          Additionally, you don’t need to worry about accidentally selling the same item to two different sites. OneShop
          automatically delists a particular item from other platforms once you have sold it. This saves you from any
          issues and inconveniences.
        </p>
        <p>
          Try out OneShop’s{' '}
          <a href='https://tools.oneshop.com/signup'>
            free <>{Constants.Marketing.TrialDuration}</>-day trial
          </a>{' '}
          today so you will be able to sell on multiple sites without the headache of common seller problems. The app
          has other great features that you can benefit from and make managing your business much easier.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
